import ContactRowList from './ContactRowList.component';

export * from './ContactRowList.component';
export default ContactRowList;